export interface MenusViewSettings {
  viewingId: number;
  menuData: any;

  showSearchBar: boolean;
  searchItem: string;
  filterTagList: any;

  currentOfferingType: string;
}
export default {
  showSearchBar: false,
  filterTagList: [],
  currentOfferingType: 'all',
} as MenusViewSettings;

export const spaceName = 'caMenu';
